import { Box, styled } from '@mui/material';

const CONTAINER_WIDTH = '400px';
const INPUT_PADDING = '0 25px';
const BORDER_RADIUS = '16px';

export const ContentContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: CONTAINER_WIDTH,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(0, 1)
}));

export const PageTitle = styled(Box)(({ theme }) => ({
  fontSize: '24px',
  lineHeight: '36px',
  fontWeight: 600,
  color: theme.palette.content.secondary
}));

export const RecipientContainer = styled(Box)({
  textAlign: 'center',
  width: '100%'
});

export const RecipientTitle = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '21px',
  fontWeight: 400,
  color: theme.palette.text.secondary,
  textAlign: 'center'
}));

export const RecipientInfo = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '21px',
  fontWeight: 500,
  color: theme.palette.content.secondary,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  overflowWrap: 'anywhere',
  gap: theme.spacing(1)
}));

export const DatePickerField = styled(Box)(({ theme }) => ({
  width: '100%',
  boxSizing: 'border-box',
  height: '56px',
  background: 'white',
  border: `solid 1px ${theme.palette.divider}`,
  borderRadius: BORDER_RADIUS,
  padding: '0 25px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer'
}));

export const DatePickerIcon = styled(Box)(({ theme }) => ({
  color: theme.palette.common.accent,
  fontSize: '16px',
  marginRight: theme.spacing(1.25)
}));

interface DateTextProps {
  selected?: boolean;
}

export const DateText = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected'
})<DateTextProps>(({ theme, selected }) => ({
  fontSize: '14px',
  lineHeight: '21px',
  color: selected ? theme.palette.content.secondary : theme.palette.content.tertiary,
  fontStyle: selected ? 'normal' : 'italic',
  flexGrow: 1,
  paddingLeft: theme.spacing(1.25)
}));


export const ButtonContainer = styled(Box)({
  display: 'flex',
  width: '100%',
  maxWidth: CONTAINER_WIDTH,
  boxSizing: 'border-box',
  padding: '0'
});

export const LoadingSpinner = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  padding: theme.spacing(4)
}));

export const SuccessIcon = styled(Box)(({ theme }) => ({
  fontSize: '48px',
  color: theme.palette.common.accent
}));

export const MessageContainer = styled(Box)(({ theme }) => ({
  gap: theme.spacing(0.5),
  padding: '0px 20px',
  fontSize: '14px',
  lineHeight: '24px',
  fontWeight: 400,
  width: '100%',
  maxWidth: CONTAINER_WIDTH,
  boxSizing: 'border-box'
}));

export const MessageText = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '21px',
  fontWeight: 'normal',
  color: theme.palette.text.secondary,
  textAlign: 'center'
}));

export const WifirstCenterText = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 500,
  display: 'inline'
}));

export const ErrorIconContainer = styled(Box)(() => ({
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  backgroundColor: '#FEF2F2',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#DC2626',
  fontSize: '30px',
  border: '1px solid #FEE2E2'
}));

export const ErrorMessage = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '21px',
  color: theme.palette.content.tertiary,
  textAlign: 'center',
  maxWidth: '350px',
  marginTop: theme.spacing(1)
}));

export const FormElementsContainer = styled(Box)({
  width: '100%',
  maxWidth: CONTAINER_WIDTH,
  boxSizing: 'border-box'
});

export const StyledLoginButton = styled(Box)(() => ({
  width: '100%',
  maxWidth: CONTAINER_WIDTH,
  boxSizing: 'border-box',
  '& .MuiButton-root': {
    borderRadius: BORDER_RADIUS,
    height: '64px',
    padding: INPUT_PADDING
  }
}));

export const GridContainer = styled(Box)({
  width: '100%',
  maxWidth: CONTAINER_WIDTH,
  boxSizing: 'border-box'
});

export const StyledLoginPaper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'auto',
  minHeight: '500px',
  padding: theme.spacing(3)
}));
